export const getContent = (path: string) => {
	const headers = {
		"Content-Type": "application/json",
		Accept: "application/json",
		"Accept-Language": "sv",
		"x-client-name": "react",
	}

	const options: RequestInit = {
		headers: headers,
		mode: "cors",
		credentials: "include",
	}

	return fetch(path, options).then((r) => {
		if (r.ok) {
			return r.json()
		} else {
			if (r.status === 307 && r.headers.has("react-location")) {
				if (typeof document !== undefined) {
					document.location = r.headers.get("react-location")
				}
			} else {
				throw new Error(`${r.status}`)
			}
		}
	})
}
